import { render, staticRenderFns } from "./ListEvaluationsReception.vue?vue&type=template&id=99d2d4aa"
import script from "./ListEvaluationsReception.vue?vue&type=script&lang=js"
export * from "./ListEvaluationsReception.vue?vue&type=script&lang=js"
import style0 from "./ListEvaluationsReception.vue?vue&type=style&index=0&id=99d2d4aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports